export const setRefreshInterval = (callback, interval) => {
  const intervalId = setInterval(callback, interval);
  return () => clearInterval(intervalId);
};